//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The bank account model
* 
* @param bankAccountId The bank account id
* @param accountHolder The bank holder (user full name)
* @param bankName The bank name
* @param bic The bank BIC
* @param iban The bank account IBAN
* @param isOrganizerBankAccount is organizer bank account
* @param isPresaleBankAccount is presale bank account
*/
@Serializable

data class BankAccount (


      /* The bank account id */
    @SerialName(value = "bankAccountId") @Required val bankAccountId: kotlin.Int = -1,


      /* The bank holder (user full name) */
    @SerialName(value = "accountHolder") val accountHolder: kotlin.String? = null,


      /* The bank name */
    @SerialName(value = "bankName") val bankName: kotlin.String? = null,


      /* The bank BIC */
    @SerialName(value = "bic") val bic: kotlin.String? = null,


      /* The bank account IBAN */
    @SerialName(value = "iban") val iban: kotlin.String? = null,


      /* is organizer bank account */
    @SerialName(value = "isOrganizerBankAccount") val isOrganizerBankAccount: kotlin.Boolean? = null,


      /* is presale bank account */
    @SerialName(value = "isPresaleBankAccount") val isPresaleBankAccount: kotlin.Boolean? = null


) {




  }

